export function RarionMark({ size, className }: { size?: number; className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 187 161"
      fill="currentColor"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="Rarion logo"
    >
      <path
        d="M 160.0 150.5 L 131.0 150.5 L 130.0 149.5 L 125.0 149.5 L 110.0 143.5 L 99.0 135.5 L 73.5 108.0 L 68.5 102.0 L 69.0 100.5 L 79.0 100.5 L 81.0 101.5 L 98.5 121.0 L 108.0 130.5 L 115.0 135.5 L 128.0 140.5 L 138.5 141.0 L 89.0 89.5 L 60.0 89.5 L 53.5 101.0 L 53.5 103.0 L 38.5 128.0 L 27.5 142.0 L 18.0 149.5 L 18.0 34.5 L 20.5 36.0 L 61.0 80.5 L 99.0 80.5 L 111.0 77.5 L 116.0 74.5 L 121.5 69.0 L 126.5 57.0 L 126.5 49.0 L 122.5 38.0 L 114.0 29.5 L 110.0 27.5 L 104.0 25.5 L 40.0 25.5 L 79.5 68.0 L 67.0 68.5 L 18.5 16.0 L 100.0 15.5 L 113.0 18.5 L 122.0 23.5 L 128.5 30.0 L 134.5 41.0 L 136.5 50.0 L 135.5 62.0 L 131.5 71.0 L 124.0 80.5 L 114.0 86.5 L 104.0 88.5 L 102.5 90.0 L 157.5 146.0 Z M 27.5 127.0 L 41.5 105.0 L 51.5 85.0 L 27.0 57.5 L 26.5 127.0 Z"
        fillRule="evenodd"
      />
    </svg>
  );
}
